import styled from 'styled-components'

export const SpinnerDiv = styled.div`
  width: ${({ $size }) => ($size != null && $size > 0 ? `${$size}px` : '40px')};
  height: ${({ $size }) => ($size != null && $size > 0 ? `${$size}px` : '40px')};
  border: 3px solid ${({ $borderColor }) => $borderColor || 'var(--vo-cloud)'};
  border-top-color: var(--color-brand);
  border-radius: 50%;
  animation: spin ${({ $speed }) => $speed || '0.8s'} linear infinite;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`
